/**
 * @graphql cc
 */
import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

import { ReadTimePopupWrapper } from './ReadTimePopupWrapper.tsx';
import { getContentFeatureExtractedEventObject } from './readTimeUtils.ts';
import { useReadTime } from './hooks/useReadTime.tsx';

export const OriginalReadTime = ({
	contentId,
	isAbbreviatedReadTime,
	isDetailsPanel,
	showWordCount,
}: {
	contentId: string;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
}): React.JSX.Element | null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const { adf, loading, error, contentType, readTime, wordCount, features, featuresSkipExpand } =
		useReadTime(contentId);

	useEffect(() => {
		if (!createAnalyticsEvent || !adf || loading || error || !contentId || !contentType) {
			return;
		}
		createAnalyticsEvent(
			getContentFeatureExtractedEventObject({ contentType, contentId, adf, isInEditor: false }),
		).fire();
	}, [contentId, loading, error, contentType, createAnalyticsEvent, adf]);

	if (error) {
		return <ErrorDisplay error={error} />;
	}
	if (readTime || (showWordCount && wordCount !== null)) {
		return (
			<ReadTimePopupWrapper
				contentId={contentId}
				isAbbreviatedReadTime={isAbbreviatedReadTime}
				isDetailsPanel={isDetailsPanel}
				showWordCount={showWordCount}
				features={features}
				featuresSkipExpand={featuresSkipExpand}
				wordCount={wordCount ?? 0}
				readTime={readTime}
				source="originalReadTime"
			/>
		);
	}

	return null;
};
